if (!customElements.get("buff-meganav")) {

  class BuffMeganav extends HTMLElement {
    constructor() {
      super();

      // Gather badges, radios, buttons, and location widget
      this.badges = this.querySelectorAll(".badge");
      this.radios = this.querySelectorAll("input.buff-meganav__dropdown__children-toggle");
      this.closeMobile = this.querySelector(".__drawer__close");
      this.openMobile = this.querySelector(".buff-meganav__left-side__hamburger");
      this.locationWidget = this.querySelector(".buff-meganav__location-widget");
      this.locationWidgetDropdown = this.locationWidget.parentElement.querySelector(".buff-meganav__dropdown");

      // Prep variable to hide and display on hover
      this.activeOriginalBadge = null;

      // Create clone
      this.clone = this.badges[0] ? this.badges[0].cloneNode(true) : null;
      if (this.clone) this.clone.classList.add('__hover-clone');

      // Store reference to scroll listener
      this.scrollListener = (e) => this.revealOriginalBadge();

      // Debounce resize event handler
      this.debounceResize = this.debounce(() => this.revealOriginalBadge(), 250);

      // Functions
      this.setupListeners();
    }

    setupListeners() {
      // Handle badges, radios, and mobile events
      this.badges.forEach((badge) => {
        const badgeLink = badge.closest("a");
        const badgeContainer = badgeLink.parentElement;
        const badgeCloneParent = badgeLink.closest(".buff-meganav__menu");

        if (badgeCloneParent) {
          badgeLink.addEventListener("mouseover", (e) => {
            // Prep clone position to replace original badge
            const viewportOffset = badge.getBoundingClientRect();
            this.clone.style.top = `${viewportOffset.top}px`;
            this.clone.style.right = `${window.innerWidth - viewportOffset.right}px`;

            // Hide original badge
            this.activeOriginalBadge = badge;
            this.activeOriginalBadge.style.opacity = "0";

            // Display clone
            badgeCloneParent.appendChild(this.clone);
            
            // Add scroll listener to container
            badgeContainer.addEventListener("scroll", this.scrollListener);
          });

          badgeLink.addEventListener("mouseout", () => {
            this.revealOriginalBadge();
          });
        }
      });

      window.addEventListener("resize", this.debounceResize);

      let lastChecked = null;

      this.radios.forEach(function(radio) {
          radio.addEventListener('click', function() {
              // If this radio was previously checked, uncheck it
              if (lastChecked === this) {
                  this.checked = false;
                  lastChecked = null; // Reset the lastChecked variable
              } else {
                  lastChecked = this; // Update lastChecked to the currently checked radio
              }
          });
      });

      this.closeMobile.addEventListener('click', () => {
        this.closeMobile.classList.remove("__open-drawer");
      });

      this.openMobile.addEventListener('click', () => {
        this.closeMobile.classList.add("__open-drawer");
      });

      // Event listener for toggling the widget's open/close state
      if (this.locationWidget) {
        this.locationWidget.addEventListener('click', (event) => {
          console.log("Widget clicked");
          if (this.locationWidget.classList.contains("__open-widget")) {
            this.locationWidget.classList.remove("__open-widget");
            // Remove the document click listener when widget is closed
            document.removeEventListener('click', this.handleDocumentClick);
          } else {
            this.locationWidget.classList.add("__open-widget");
            // Add the document click listener when widget is opened
            document.addEventListener('click', this.handleDocumentClick);
          }

          // Prevent click from bubbling to the document
          event.stopPropagation();
        });
      }
    }

    // Handle clicks outside the widget
    handleDocumentClick = (event) => {
      // Check if the click happened outside the widget
      if (
        this.locationWidget &&
        this.locationWidget.classList.contains("__open-widget") &&
        !this.locationWidget.contains(event.target) &&
        !this.locationWidgetDropdown.contains(event.target)
      ) {


        // Close the widget if the click is outside
        this.locationWidget.classList.remove("__open-widget");
        // Remove the document click listener after closing the widget
        document.removeEventListener('click', this.handleDocumentClick);
      }
    };

    revealOriginalBadge() {
      if (this.clone.parentElement) {
        this.clone.remove();
      }
      if (this.activeOriginalBadge) {
        this.activeOriginalBadge.style.opacity = "1";
        const badgeLink = this.activeOriginalBadge.closest("a");
        const badgeContainer = badgeLink.parentElement;
        badgeContainer.removeEventListener("scroll", this.scrollListener);
        this.activeOriginalBadge = null;
      }
    }

    debounce(func, wait) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.debounceResize);
      this.badges.forEach((badge) => {
        const badgeLink = badge.closest("a");
        const badgeContainer = badgeLink.parentElement;
        badgeContainer.removeEventListener("scroll", this.scrollListener);
      });
    }
  }
    
  customElements.define( "buff-meganav", BuffMeganav);
}
